import { api } from '@/lib/api'

import { CompanyOwner } from '../types'

export function updateBeneficialOwner(data: CompanyOwner) {
  const { id, ...rest } = data

  return api.put<CompanyOwner>(`/v1/onboarding/beneficial-owners/${id}`, rest)
}
